let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2nHxT")).then(() => parcelRequire('5RnXN'));